export default __webpack_public_path__ + "static/media/022-giraffe.875cbedf.svg";